/** Ampel-Punkt + Text — die eine Statusanzeige des Redesigns (Kundenliste, Heute, Kundenkopf). */
import type { AmpelStatus } from '@/lib/analytics-api';

const FARBE: Record<AmpelStatus | 'rot' | 'gelb', string> = {
  gruen: 'bg-emerald-500',
  gelb: 'bg-amber-400',
  rot: 'bg-red-500',
  grau: 'bg-gray-300',
  keine: 'bg-transparent',
};

export function AmpelPunkt({ status, className = '' }: { status: AmpelStatus | 'rot' | 'gelb'; className?: string }) {
  if (status === 'keine') return null;
  return <span className={`inline-block w-2 h-2 rounded-full flex-shrink-0 ${FARBE[status]} ${className}`} />;
}

export default function Ampel({ status, text, className = '' }: { status: AmpelStatus; text: string; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-1.5 text-[13px] ${status === 'keine' ? 'text-gray-300' : 'text-gray-700'} ${className}`}>
      <AmpelPunkt status={status} />
      <span className="truncate">{text}</span>
    </span>
  );
}
